import React from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../components/Layout/DashboardLayout';
// import MetricCard from '../../components/ui/MetricCard'; // If you plan to use metrics
// import CheckinStep from '../../components/ui/CheckinStep'; // Import CheckinStep if you plan to use it

// SVG Icons from the provided HTML graphic
const AlertInfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 25 24" fill="#01844B">
        <path d="M12.5 2L1.5 21H23.5M12.5 6L20.03 19H4.97M11.5 10V14H13.5V10M11.5 16V18H13.5V16" fill="#000000" />
    </svg>
);

const StatusCompletedIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="me-2" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="img" alt="Completado">
        <title>Completado</title>
        <circle cx="8" cy="8" r="8" fill="#01844B" />
        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" fill="#FFFFFF" />
    </svg>
);

const StatusPendingIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-muted me-2" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="img" alt="Pendiente">
        <title>Pendiente</title>
        <circle cx="8" cy="8" r="7" />
    </svg>
);


const HomeAdminScreen = () => {
    // Placeholder data - this would typically come from an API
    const adminName = "Admin User"; // Example, fetch dynamically

    return (
        <DashboardLayout activeMenuItem="Inicio" userName={adminName} userRole="admin">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-0">¡Bienvenido/a, Administrador!</h1>
                <div className="btn-toolbar mb-2 mb-md-0">
                    {/* Example: Button for a primary admin action, e.g., System Settings */}
                    <Link to="/settings" className="btn btn-checkin d-flex align-items-center">
                        {/* You might want a specific icon here, e.g., <i className="bi bi-gear-fill me-2"></i> */}
                        Configuración General
                    </Link>
                </div>
            </div>

            {/* Replaced AlertMessage component with manual structure to include SVG */}
            <div className="alert alert-info-custom d-flex align-items-start" role="alert">
                <AlertInfoIcon />
                <span>Bienvenido al panel de administración. Desde aquí puedes gestionar usuarios, proveedores y la configuración del sistema.</span>
            </div>

            <h3 className="mb-3 mt-4">Acciones Rápidas</h3>
            <p className="mb-4 text-muted">Accesos directos a las funciones principales del sistema.</p>

            <div className="list-group gap-3">
                <Link to="/users" className="list-group-item list-group-item-action">
                    Gestionar Usuarios
                </Link>
                <Link to="/settings/faqs" className="list-group-item list-group-item-action">
                    Gestionar FAQS
                </Link>
                <Link to="/settings/quiz-manager" className="list-group-item list-group-item-action">
                    Gestionar Cuestionarios
                </Link>
            </div>

            {/* New section: Tu ruta como proveedor */}
            <h3 className="mb-3 mt-4">Tu ruta como administrador</h3> {/* Changed title to be admin-specific */}
            <p className="mb-4 text-muted">Pasos clave en tu rol de administrador.</p>

            <div className="list-group gap-3">
                <div className="list-group-item d-flex align-items-center border-0 p-4">
                    <StatusCompletedIcon />
                    <span>Configuración inicial completa</span> {/* Example step */}
                </div>
                <div className="list-group-item d-flex align-items-center border-0 p-4">
                    <StatusPendingIcon />
                    <span>Revisar solicitudes pendientes</span> {/* Example step */}
                </div>
                {/* Add more admin-specific steps as needed */}
            </div>
        </DashboardLayout >
    );
};

export default HomeAdminScreen;
